export enum Styles {
    productItemContainer = "isi-container",
}
